import styled from "styled-components";
import Button from "../../components/Button";
import { Colors } from "../../config/Constants";
import Modal from "../Modal";
type ConfirmModalProp = {
  heading: string;
  subHeading?: string;
  button1Label: string;
  button2Label: string;
  button1Submit: () => void;
  button2Submit: () => void;
  setOpenOrClose: (a: boolean) => void;
};
type styledProp = {
  subHeadingExists: string | null;
};
const ConfirmModal = ({
  heading,
  subHeading,
  button1Label,
  button2Label,
  button1Submit,
  button2Submit,
  setOpenOrClose,
}: ConfirmModalProp) => {
  return (
    <Modal variant="none" width="28rem" setOpenOrClose={setOpenOrClose}>
      <ConfirmPopupStyled>
        <ConfirmHeader subHeadingExists={subHeading || null}>
          {heading}
        </ConfirmHeader>
        <ConfirmSubHeader subHeadingExists={subHeading || null}>
          {subHeading}
        </ConfirmSubHeader>
        <ConfirmButtonWrapper subHeadingExists={subHeading || null}>
          <ButtonWrapper>
            <Button
              label={button1Label}
              size="medium"
              onClick={button1Submit}
            />
          </ButtonWrapper>
          <ButtonWrapper>
            <Button
              label={button2Label}
              variant="filled"
              color={Colors.solidRed}
              size="medium"
              onClick={button2Submit}
            />
          </ButtonWrapper>
        </ConfirmButtonWrapper>
      </ConfirmPopupStyled>
    </Modal>
  );
};

export default ConfirmModal;

const ConfirmPopupStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const ConfirmHeader = styled.div<styledProp>`
  margin-top: ${(props) => (props.subHeadingExists ? "1.8rem" : "4rem")};
  font-family: "Poppins-Medium";
  color: ${Colors.mineShaft};
  font-size: 1rem;
`;
const ConfirmSubHeader = styled.div<styledProp>`
  font-family: "Poppins-Book";
  font-size: 1rem;
  color: ${Colors.mineShaft};
  margin-top: ${(props) => (props.subHeadingExists ? "1.7rem" : "0")};
  width: 18rem;
`;
const ConfirmButtonWrapper = styled.div<styledProp>`
  display: flex;
  margin-top: ${(props) => (props.subHeadingExists ? "2.6rem" : "3rem")};
  margin-bottom: ${(props) => (props.subHeadingExists ? "3.75rem" : "3.75rem")};
  gap: 1.5rem;
`;
const ButtonWrapper = styled.div`
  width: 9.7rem;
  height: 3rem;
`;
